import { render, staticRenderFns } from "./carbonMarket.vue?vue&type=template&id=0d5fc2b7&scoped=true"
import script from "./carbonMarket.vue?vue&type=script&lang=js"
export * from "./carbonMarket.vue?vue&type=script&lang=js"
import style0 from "./carbonMarket.vue?vue&type=style&index=0&id=0d5fc2b7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d5fc2b7",
  null
  
)

export default component.exports